export default {
  menu: {
    home: '首页',
    alliance: '我的联盟',
    mall: '口袋商城',
    me: '关于我们'
  },
  layout: {
    loading: '加载中',
    trading: '交易中，请稍候...',
    comingsoon: '即将到来',
    success:'成功',
    error:'失败'
  },
  header: {
    home: '首页',
    alliance: '我的联盟',
    mall: '口袋商城',
    about: '关于我们',
    lang: {
      zh: '简体中文',
      zhTW: '繁体中文',
      en: 'English',
      ko: '한국어',
      ja: '日本語'
    }
  },
  period: {
    m5: '5分',
    m15: '15分',
    h1: '1小时',
    h4: '4小时',
    d1: '日',
    w1: '周',
    m1: '月'
  },
  home: {
    slogan1: '让资产增值',
    slogan2_part1: '从',
    slogan2_pocket: '口袋',
    slogan2_part2: '开始',
    slogan3: '安全·稳健·高收益',
    explore: '探索更多',
    alliance_pack: '口袋联盟配套',
    alliance_desc: '最高可开出价值 5000元珍藏卡牌,赠送 口袋通证，累计最高可享 360元福利回馈！…',
    join_alliance: '加入口袋联盟',
    mall: '口袋商城',
    mall_desc: '不只是购物，更是一种储蓄。',
    ecosystem: '战略伙伴-DRS ',
    ecosystem_desc: '为合作社赋能，为公务员减负。',
    referrer_title: '推荐人地址',
    referrer_placeholder: '请输入推荐人地址',
    confirm: '确认'
  },
  alliance: {
    mint_pool: '铸币池',
    token_count: 'TOKEN数量',
    usdt_total: 'USDT总量',
    open_price: '开盘价',
    current_value: '当前价值',
    static_income: '静态收益',
    my_token: '我的TOKEN数量',
    withdraw: '提现',
    fill_address: '填写地址',
    view_receipt: '查看收货',
    dynamic_income: '动态收益',
    current_node: '当前为',
    large_node: '大节点',
    repurchase_count: '复购次数',
    current_pack: '当前配套',
    max_return: '最大收益',
    withdrawn_income: '已提现收益',
    current_income: '当前收益',
    my_pack: '我的配套',
    referrer_address: '推荐人地址',
    community_subsidy: '社区补贴',
    buy_node: '购买节点',
    my_team: '我的团队',
    team_pack: '团队配套',
    team_small_node: '团队小节点',
    team_large_node: '团队大节点',
    my_referrals: '我的推荐',
    node: '节点',
    date: '日期',
    small_node: '小节点',
    recommend: '推荐',
    high_return: '高收益',
    buy: '购买',
    small_node_desc: '适合个人用,性价比高,轻松参与生态建设',
    large_node_desc: '适合个人用户,性价比高,轻松参与生态建设',
    fill_receipt_info: '填写收货信息',
    select_region: '选择地区',
    select_address: '地址',
    receiver: '收货人',
    phone: '联系电话',
    submit: '确认提交',
    cancel: '取消',
    purchase_node: '购买节点',
    select_node: '选择您要购买的节点',
    your_address: '您的收货地址',
    your_phone: '您的联系电话',
    shipping_status: '发货状态',
    shipp: '待发货',
    shipped: '已发货',
    shipping_method: '快递方式',
    tracking_number: '快递单号',
    close: '确认关闭',
    postcode:'邮政编码',
    endvalue:'最终收益',
    copylink:'复制邀请链接',
    fundinfo:'明细',
    myorder:'我的订单',
    orderno:'订单号',
    getthings:'领取',
    geted:'已领取',
    gettime:'领取时间',
    packamount:'配套金额',
    nonode:'暂无',
    teamsub:'社区补贴',
    pocketname:'口袋联盟',
    pocketname1:'感谢您的支持与参与！',
    pocketname2:'请前往指定线下门店领取商品。祝您欧气满满，好运加倍，抽中心意珍卡！',
    nodealert:'需要推荐',
    nodealert2:'人',
  },
  me: {
    about_alliance: '关于口袋联盟',
    alliance_rule1: '口袋联盟 是一个以 Web3 为核心的创新生态联盟，致力于打造一个集 消费增值、储蓄增值、收藏增值、金融增值 于一体的价值生态系统。',
    alliance_rule2: '我们希望通过简单、易懂、低门槛的方式，让更多普通人能够接触并参与 Web3 时代的发展机遇，实现财富价值的长期积累与增长。',
    alliance_rule3:'口袋联盟以 桌游社交 为入口，通过轻松有趣的互动方式建立人与人之间的信任与连接；以 社区共建 为基础，通过分享、学习与协作，构建一个充满活力的价值网络。',
    alliance_rule4:'在口袋联盟生态中，消费不再只是支出，储蓄不再只是沉淀，收藏不再只是爱好，而是能够持续创造价值的生态循环。',
    alliance_rule5:'我们的愿景',
    alliance_rule6:'让每一个人都拥有属于自己的价值口袋，在 Web3 时代锁定财富、积累财富、传承财富。',
    alliance_rule7:'我们的使命',
    alliance_rule8:'以社交连接价值，以生态创造增值，让 Web3 走进千家万户。',
    alliance_rule9:'我们的核心价值',
    alliance_rule10:'💰 消费增值 —— 让每一次消费更有价值',
    alliance_rule11:'🏦 储蓄增值 —— 让资金拥有成长的机会',
    alliance_rule12:'🃏 收藏增值 —— 让兴趣成为资产',
    alliance_rule13:'📈 金融增值 —— 让价值实现持续流动',
    alliance_rule14:'🤝 社区共建 —— 让分享创造更大价值',
    alliance_rule15:'🌐 Web3赋能 —— 让人人都能参与未来经济',
    alliance_rule16:'口袋联盟——把消费变成资产，把社交变成价值，把未来装进口袋。',
    alliance_rule17:'口袋联盟-让会员口袋都有钱',
    about_node: '关于节点',
    node_rule1: '1. 投资300U，成为小节点',
    node_rule2: '2. 投资800U，成为大节点',
    pocketname:'口袋通证',
    pocketprice:'当前市值',
    pockettrade:'交易额',
  },
  mall: {
    coming_soon: '即将到来...'
  },
  chart: {
    open: '开盘',
    close: '收盘',
    high: '最高',
    low: '最低',
    change: '涨跌额',
    change_rate: '涨跌幅',
    volume: '成交量'
  }
};
